import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Oznacz środki wypłacone',
  type: 'object',

  properties: {
    date: {
      fieldRequired: true,
      format: 'date',
      title: 'Data wypłacenia środków',
      type: 'string'
    },

    packIds: {
      minItems: 1,
      title: 'Wybierz paczki płatności: *',
      type: 'array',

      items: {
        type: 'number'
      }
    }
  },

  allOf: [validationMessages]
};
